import { UtilitarioService } from '@app/services/utilitario.service';

export class MinhaAgendaTransferenciaPesquisa {

  ParticipanteId: number;
  DataInicial: string;
  DataFinal: string;
  MostrarSomenteTransferidas: boolean;
  constructor() {
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);
  }
}
